<template>
  <span class="loader"></span>
</template>

<script>
export default {
  name: "InfoRunner"
};
</script>

<style scoped>
.loader {
  @apply w-12 h-12 block relative mx-auto;
}

.loader::after,
.loader::before {
  content: "";
  box-sizing: border-box;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid;
  border-color: black;
  border-color: var(--color-primary-core);
  position: absolute;
  left: 0;
  top: 0;
  animation: animloader 2s linear infinite;
  opacity: 0.1;
}
.loader::after {
  animation-delay: 1s;
}

@keyframes animloader {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
</style>
